/**
 * @file SearchToolbar.tsx
 * @description Shared search toolbar component
 * @module components/shared
 */

import type { ReactNode } from 'react';
import { Paper, Group, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

interface SearchToolbarProps {
  /** Search value */
  search: string;
  /** Search change handler */
  onSearchChange: (value: string) => void;
  /** Search placeholder */
  placeholder?: string;
  /** Additional controls to render after search */
  children?: ReactNode;
}

/**
 * Reusable search toolbar with refresh button
 */
export function SearchToolbar({
  search,
  onSearchChange,
  placeholder = 'Search...',
  children,
}: SearchToolbarProps) {
  return (
    <Paper withBorder p="md" mb="md">
      <Group>
        <TextInput
          placeholder={placeholder}
          leftSection={<IconSearch size={16} />}
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          style={{ flex: 1 }}
        />
        {children}
      </Group>
    </Paper>
  );
}
